var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"popover",staticClass:"popover"},[(_vm.visible)?_c('div',{ref:"contentWrapper",staticClass:"content-wrapper",class:( _obj = {}, _obj[("position-" + _vm.position)] = true, _obj )},[_vm._t("content",null,{close:_vm.close})],2):_vm._e(),_vm._v(" "),_c('span',{ref:"triggerWrapper",staticStyle:{"display":"inline-block"}},[_vm._t("default")],2)])
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03562c95","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/popover/bf-popover.vue
// module id = 59
// module chunks = 0